import { LitElement, html } from 'lit';
import { state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { LOADER_WIDGETS, LoaderWidgetType } from './constants';

export class GzDashboardLoadingScreenWebComponent extends LitElement {
  @state()
  private readonly widgets = LOADER_WIDGETS;

  static get styles() {
    return styles;
  }

  renderWidgetLoader(widget) {
    let loaderContentClassName = 'column';
    let loaderContent = html`<gz-loader class="dashboard-loader" rows="6"></gz-loader>`;
    const { type, height, width } = widget;

    if (type === LoaderWidgetType.FULL_FOUR_COLUMNS) {
      // overview widget with 4 columns
      loaderContentClassName = 'column-4';
      loaderContent = this.renderWidgetLoaderColumns(4);
    } else if (type === LoaderWidgetType.FULL_TWO_COLUMNS) {
      // inventory widget with 2 columns
      loaderContentClassName = 'column-2';
      loaderContent = this.renderWidgetLoaderColumns(2);
    }

    return html` <div class="item height-${height} width-${width} ${loaderContentClassName}">
      <div class="content-wrapper">${loaderContent}</div>
    </div>`;
  }

  renderWidgetLoaderColumns(columns: number) {
    const loaderTemplate = html`<div class="item-content"><gz-loader class="dashboard-loader"></gz-loader></div>`;

    return html` ${[...Array(columns)].map(() => {
      return loaderTemplate;
    })}`;
  }

  render() {
    return html` <div class="loaders-grid">${this.widgets.map(widget => this.renderWidgetLoader(widget))}</div> `;
  }

  constructor() {
    super();
  }
}
